import _taggedTemplateLiteral from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf2 from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _templateObject;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _decorate from "@babel/runtime/helpers/esm/decorate";
import _get from "@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

var _ = function _(t) {
  return t;
},
    _t;
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import { customElement, html, LitElement } from 'lit-element';
import { BUTTON_KIND } from 'carbon-web-components/es/components/button/defs';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import styles from "./button-group.css.js";
var ddsPrefix = ddsSettings.stablePrefix;
/**
 * Button group.
 *
 * @element dds-button-group
 */

var DDSButtonGroup = _decorate([customElement("".concat(ddsPrefix, "-button-group"))], function (_initialize, _LitElement) {
  var DDSButtonGroup = /*#__PURE__*/function (_LitElement2) {
    _inherits(DDSButtonGroup, _LitElement2);

    var _super = _createSuper(DDSButtonGroup);

    function DDSButtonGroup() {
      var _this;

      _classCallCheck(this, DDSButtonGroup);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return DDSButtonGroup;
  }(_LitElement);

  return {
    F: DDSButtonGroup,
    d: [{
      kind: "method",
      key: "_handleSlotChange",
      value:
      /**
       * Handler for @slotchange, set the first button-group-item to kind tertiary and primary for the remaining ones
       *
       * @private
       */
      function _handleSlotChange(event) {
        var _this2 = this;

        var childItems = event.target.assignedNodes().filter(function (elem) {
          return elem.matches !== undefined ? elem.matches(_this2.constructor.selectorItem) || elem.matches(_this2.constructor.selectorItemCTA) : false;
        });
        childItems.forEach(function (elem, index) {
          elem.setAttribute('kind', index !== childItems.length - 1 ? BUTTON_KIND.TERTIARY : BUTTON_KIND.PRIMARY);
        });
        var customPropertyItemCount = this.constructor.customPropertyItemCount;
        this.style.setProperty(customPropertyItemCount, String(childItems.length));
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        return html(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <slot @slotchange=\"", "\"></slot>\n    "])), 0)), this._handleSlotChange);
      }
    }, {
      kind: "method",
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(DDSButtonGroup.prototype), "connectedCallback", this).call(this);

        this.setAttribute('role', 'list');
      }
      /**
       * The CSS custom property name for the live button group item cout.
       */

    }, {
      kind: "get",
      static: true,
      key: "customPropertyItemCount",
      value: function customPropertyItemCount() {
        return "--".concat(ddsPrefix, "--button-group--item-count");
      }
      /**
       * A selector that will return the child items.
       */

    }, {
      kind: "get",
      static: true,
      key: "selectorItem",
      value: function selectorItem() {
        return "".concat(ddsPrefix, "-button-group-item");
      }
      /**
       * A selector that will return the child items.
       */

    }, {
      kind: "get",
      static: true,
      key: "selectorItemCTA",
      value: function selectorItemCTA() {
        return "".concat(ddsPrefix, "-button-cta");
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function stableSelector() {
        return "".concat(ddsPrefix, "--button-group");
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value: function value() {
        return styles;
      }
    }]
  };
}, LitElement);

export default DDSButtonGroup;